"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.troubleshootAvailableTimes = troubleshootAvailableTimes;
exports.getOverlappingTimeRangeWithMeeting = getOverlappingTimeRangeWithMeeting;
exports.troubleshootTimeRanges = troubleshootTimeRanges;
exports.troubleshootMinimumNoticeTime = troubleshootMinimumNoticeTime;
exports.troubleshootPastStartTimes = troubleshootPastStartTimes;
exports.removeTimesWithoutReasons = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _filter = _interopRequireDefault(require("transmute/filter"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _map = _interopRequireDefault(require("transmute/map"));

var _TroubleshotStartTime = _interopRequireDefault(require("MeetingsLib/models/TroubleshotStartTime"));

var _enums = require("MeetingsLib/constants/enums");

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

function troubleshootAvailableTimes(allPossibleStartTimes, availableStartTimes) {
  /**
   * @param {List} allPossibleStartTimes List of possible start timestamps
   * @param {List} availableStartTimes List of available start timestamps
   * @returns {List} Returns List of TroubleshotStartTimes without reasons, where
   * the available ones have busy: false
   *
   * Available times are calculated by chunking the non-busy time range into even
   * meeting-length intervals, or 15-minute intervals, depending on gates.
   * If 10 - 11 is available, and 10 - 10:20 is a busy event, and meeting length
   * is 6 minutes, available times will be calculated at 10:20, 10:26, 10:32 etc.
   *
   * These times won't match up with the total set of possible start times, which
   * will be calculated as 10, 10:06, 10:12, 10:18, 10:24 etc. Therefore we need
   * to add the non-matching available times to the set of possible start times
   * if they are not already there.
   */
  var mapOfAvailableTimes = availableStartTimes.groupBy(_identity.default);
  var troubleshotMatchingTimes = allPossibleStartTimes.map(function (time) {
    var timeIsAvailable = mapOfAvailableTimes.get(time);
    mapOfAvailableTimes = mapOfAvailableTimes.delete(time);
    return new _TroubleshotStartTime.default({
      time: time,
      busy: !timeIsAvailable
    });
  });
  var troubleshotNonMatchingAvailableTimes = mapOfAvailableTimes.keySeq().toList().map(function (time) {
    return new _TroubleshotStartTime.default({
      time: time,
      busy: false
    });
  });
  return troubleshotMatchingTimes.concat(troubleshotNonMatchingAvailableTimes);
}

function getOverlappingTimeRangeWithMeeting(startTime, duration, timeRangesWithDescriptions) {
  /**
   * @param {int} startTime A meeting start time
   * @param {int} duration Meeting length in milliseconds
   * @returns {TimeRangeWithDescription} The first time range with description, that
   * overlaps with a meeting starting at the specified start time
   */
  var meetingAtStartTime = _TimeRange.default.from({
    start: startTime,
    end: startTime + duration
  });

  return timeRangesWithDescriptions.find(function (timeRangeWithDescriptions) {
    return timeRangeWithDescriptions.timeRange.hasIntersection(meetingAtStartTime);
  });
}

function troubleshootTimeRanges(duration, timeRangesWithDescriptions) {
  /**
   * @param {int} duration Meeting length in milliseconds
   * @param {List} timeRangesWithDescriptions A list of busy time ranges in which we
   * want to troubleshoot overlapping start times
   * @returns {function} Returned function accepts a List of TroubleshotStartTimes
   * Does not touch available times or ones with reasons
   * Finds a time range that overlaps with each start time, and tags the start time
   * with the busy-reason of the overlapping time range.
   */
  return (0, _map.default)(function (timeWithReason) {
    if (timeWithReason.reason || !timeWithReason.busy) {
      return timeWithReason;
    }

    var overlappingTimeRange = getOverlappingTimeRangeWithMeeting(timeWithReason.time, duration, timeRangesWithDescriptions);

    if (overlappingTimeRange) {
      return new _TroubleshotStartTime.default((0, _extends2.default)({}, overlappingTimeRange.toObject(), {
        reason: overlappingTimeRange.type,
        busy: true,
        time: timeWithReason.time
      }));
    }

    return timeWithReason;
  });
}

function troubleshootMinimumNoticeTime(now, minimumNoticeTime) {
  /**
   * @param {int} now - Timestamp representing the app loading
   * @param {int} minimumNoticeTime - Milliseconds for which a meeting cannot be booked
   * @returns {function} Returned function accepts a List of TroubleshotStartTimes
   * Tags start times that are before the minimum notice time cutoff with the
   * MINIMUM_NOTICE reason
   */
  var minimumNoticeTimeCutoff = now + minimumNoticeTime;
  return (0, _map.default)(function (timeWithReason) {
    if (timeWithReason.time < minimumNoticeTimeCutoff) {
      return timeWithReason.set('reason', _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE);
    }

    return timeWithReason;
  });
}

function troubleshootPastStartTimes(startTimes, now) {
  /**
   * @param {List} startTimes List of start timestamps
   * @param {int} now - Timestamp representing the app loading
   * @returns {List} Returns troubleshot times that are busy because they're in the past
   */
  return startTimes.filter(function (time) {
    return time < now;
  }).map(function (time) {
    return new _TroubleshotStartTime.default({
      time: time,
      busy: true,
      reason: _enums.UNAVAILABLE_REASONS.PAST
    });
  });
}

var removeTimesWithoutReasons = (0, _filter.default)(
/**
 * @param {List} troubleshotStartTimes List of troubleshot start times
 * @returns {List} Removes troubleshot times that are busy without reasons
 */
function (timeWithReason) {
  return !timeWithReason.busy || timeWithReason.reason;
});
exports.removeTimesWithoutReasons = removeTimesWithoutReasons;